// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import encryptStorage from './libs/encryptStorage';
import router from './router';

Vue.config.productionTip = true;

Vue.http.interceptors.push(function (request) {
    request.headers.set('Authorization', sessionStorage.getItem('sbc-token'));

    return function (res) {
        if (res.status == 401) {
            encryptStorage.removeItem('ur');
            encryptStorage.removeItem('rr');
            sessionStorage.removeItem('sbc-token');
            sessionStorage.removeItem('tableFilter');
            sessionStorage.setItem('session-expired', true);
            location.reload();
        }
    };
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js